module.exports = ["Alloy","Aluminum","Carbon Alloy","Carbon","Copper Brass","High Temp","Stainless","Titanium"]


//////////////////
// WEBPACK FOOTER
// ./src/config/material.json
// module id = 5424
// module chunks = 1